import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  const names = ['Martín', 'Lucas', 'Diego', 'Pablo', 'Federico', 'Joaquín', 'Nicolás', 'Matías', 'Andrés', 'Sebastián', 'Gonzalo', 'Tomás', 'Agustín', 'Sofía', 'Camila', 'Lucía', 'Florencia', 'Valentina'];
  const cities = ['Buenos Aires', 'Rosario', 'Córdoba', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Juan', 'Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca', 'Santa Fe', 'Paraná', 'Corrientes', 'Resistencia'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const interval = setInterval(showPopup, Math.random() * 10000 + 15000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-123">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-124">
          <div className="bg-white rounded-lg shadow-2xl border-2 border-[#C6FF3C] p-4 flex items-start gap-3" data-id="element-125">
            <img src="https://cdn.magicpatterns.com/uploads/nwZD7wQNkfvSiQBuu1oc8X/7c1eda8a-fa45-4a31-8042-481caea61529-removebg-preview.png" alt="Product" className="w-16 h-16 object-contain flex-shrink-0" data-id="element-126" />
            <div className="flex-1" data-id="element-127">
              <p className="text-sm font-bold text-black mb-1" data-id="element-128">
                {currentPurchase.name} de {currentPurchase.city}
              </p>
              <p className="text-xs text-gray-600" data-id="element-129">
                acaba de comprar{' '}
                <span className="font-semibold" data-id="element-130">PADEL SMART PRO ELITE</span>
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-131">hace 3 minutos</p>
            </div>
            <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600" data-id="element-132">
              <X className="w-4 h-4" data-id="element-133" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}